import Skeleton from '@mui/material/Skeleton';

import { BoxStyled } from '../components/RolesForm/RolesForm.styled';

export const RolesEditFormSkeleton: React.FC = () => (
  <BoxStyled>
    <Skeleton height={40} sx={{ gridColumn: '1 / span 3' }} variant="rounded" />
    <Skeleton height={40} variant="rounded" />
    <Skeleton height={40} sx={{ gridColumn: '1 / span 2' }} variant="rounded" />
    <Skeleton height={40} sx={{ gridColumn: '3 / span 2' }} variant="rounded" />
  </BoxStyled>
);
